import { createStore } from 'vuex';

const store = createStore({
    state() {
        return {
            // フォームデータ
            scrollTopBeforeReload: 0,
            os: "win",
            cmd: "testrun",
            anyTestUser: "",
            anyTestApiKey: "",
            anyTestDeviceId: "162",
            anyTestRunTime: "5",
            anyTestProxyAddress: "",
            anyTestProxyPort: "",
            anyTestProxyAccount: "",
            anyTestProxyPassword: "",
            authProxyAddress: "",
            authProxyPort: "",
            authProxyAccount: "",
            authProxyPassword: "",
            browserChrome: false,
            browserEdge: false,
            browserFireFox: false,
            browserAnyTest: false,
            browserBackground: true,
            qtWorkspace: "",
            qtApiKey: "",
            qtTdashTestrun: "",
            qtQtProject: "",
            qtUsePreviousTestrun: false,
            qtStartDate: "",
            qtEndDate: "",
            qtProxyAddress: "",
            qtProxyPort: "",
            qtProxyAccount: "",
            qtProxyPassword: "",
            reportsDir: "",
            silent: true,
            syncNotUseExistingTest: true,
            syncDir: "",
            testrunMemo: "",
            testrunNames: [{ name: '' }],
            testProxyAddress: "",
            testProxyPort: "",
            testProxyAccount: "",
            testProxyPassword: "",
            testProxyUrl: "",
            winAppName: "",
            winAppPath: "",
        };
    },
    mutations: {
        setValue(state, payload) {
            state[payload.key] = payload.value;
        }
    },
    actions: {
        saveValue({ commit }, payload) {
            commit('setValue', payload);
        }
    }
});

export default store;
